import angular from 'angular';
import { uiSrefRemoveOriginal } from './uiSrefRemoveOriginal';
import { uiSrefDirective } from './uiSrefDirective';

angular.module('sh.uiSref', []).config(uiSrefRemoveOriginal).directive('uiSref', uiSrefDirective);
